import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../Style/dashboard.css";

const DashboardCard = ({ title, count, amount, icon, color, path }) => {
  const navigate = useNavigate();

  const [countValue, setCountValue] = useState(0);
  const targetValue = count ?? amount ?? 0;

  useEffect(() => {
    let start = 0;
    const duration = 800;
    const stepTime = 20;
    const steps = duration / stepTime;
    const increment = Math.ceil(targetValue/steps);

    const timer = setInterval(() => {
      start +=increment;
      if(start >= targetValue){
        setCountValue(targetValue);
        clearInterval(timer);
      }else{
        setCountValue(start);
      }
    },30);
    return () => clearInterval(timer);
  },[targetValue]);

  return (
    <Card
      className="dashboard-card text-white"
      style={{
        backgroundColor: color,
        borderRadius: "10px",
        minHeight: "100px",
      }}
    >
      <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center">
        
        {/* ICON */}
        <div className="card-icon mb-2">
          {icon}
        </div>

        {/* COUNT */}
        {count !== undefined && (
          <h4 className="mb-1">{countValue}</h4>
        )}

        {amount !== undefined && (
            <h4 className="mb-2">{countValue}</h4>
        )}

        {/* TITLE */}
        <h6 className="mb-3">{title}</h6>

        {/* BUTTON */}
        <Button
          size="sm"
          variant="light"
          className="view-btn"
          onClick={() => navigate(path)}
        >
          View Details
        </Button>

      </Card.Body>
    </Card>
  );
};

export default DashboardCard;
